const convertToChosen = (data) => {
  return data.map(d => {
    return {
      'value': d,
      'text': d
    }
  })
}

export default ({
  namespaced: true,
  state: {},
  getters: {
    recommendations: (state, getters, rootState) => {
      return rootState.recommendations.filter(function(r) {
        return r.service === 'Medical Inspections'
      })
    },
    cycles: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.cycle))])
    },
    publishYears: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => new Date(r.publishedDate).getFullYear()))].sort().reverse())
    },
    associatedEntities: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.entity))].sort())
    },
    reports: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.report))].sort())
    },
    reportNumbers: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.reportNumber))].sort())
    },
    recommendationNumbers: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.number))].sort())
    },
    indicators: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.indicator))].sort((a, b) => {
        let mitA = a.split(' ')
        let mitB = b.split(' ')
        if (parseInt(mitA[1]) < parseInt(mitB[1])) return -1
        if (parseInt(mitA[1]) > parseInt(mitB[1])) return 1
        if (parseInt(mitA[1]) === parseInt(mitB[1])) return 0
      }))
    },
    filterValues: (state, getters) => {
      return {
        cycles: getters.cycles,
        publishYears: getters.publishYears,
        associatedEntities: getters.associatedEntities,
        indicators: getters.indicators,
        reports: getters.reports,
        reportNumbers: getters.reportNumbers,
        recommendationNumbers: getters.recommendationNumbers
      }
    }
  },
  mutations: {},
  actions: {}
})
